import * as React from "react";

const Money = ({ price }: { price: string }): JSX.Element => {
  /* to make it more elaborate */
  const country = {
    AUD: "$",
    GBP: "￡",
    EUR: "€",
    HKD: "$",
    NZD: "$",
    SGD: "$",
    USD: "$",
  };

  return <span>{`${country["AUD"]}${parseFloat(price).toFixed(2)}`}</span>;
};

export default Money;
